import { keepPreviousData, useQuery, UseQueryResult } from '@tanstack/react-query';
import {
  fetchAuditEventById,
  fetchAuditEvents,
  fetchOrgAuditEvents,
  type AuditEvent,
  type AuditEventListParams,
  type AuditEventsListResponse,
} from '../api/audit.api.ts';
import { adminQueryKeys } from './queryKeys.ts';

export type AuditEventsScope = 'platform' | 'org';

export const useAuditEvents = (
  params: AuditEventListParams,
  options?: { enabled?: boolean; scope?: AuditEventsScope },
): UseQueryResult<AuditEventsListResponse, Error> => {
  const scope: AuditEventsScope = options?.scope === 'org' ? 'org' : 'platform';
  return useQuery({
    queryKey: adminQueryKeys.audit.list(params as Record<string, unknown>, scope),
    queryFn: () => (scope === 'org' ? fetchOrgAuditEvents(params) : fetchAuditEvents(params)),
    placeholderData: keepPreviousData,
    enabled: options?.enabled !== false,
  });
};

export const useAuditEvent = (
  id: string | null,
): UseQueryResult<AuditEvent, Error> => {
  return useQuery({
    queryKey: adminQueryKeys.audit.detail(id ?? ''),
    queryFn: () => fetchAuditEventById(id as string),
    enabled: Boolean(id),
  });
};
